var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMaster1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 747,
    height: 809,
    viewBox: "0 0 747 809",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M683.7 592.8L515 622.8L373.3 808.2L231.6 622.8L62.9001 592.8L90 377.5L0.300049 82.7002L231.6 132.1L373.3 0.299805L515 132.1L746.4 82.7002L656.6 377.5L683.7 592.8Z",
    fill: "#7D87C9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M373.3 396.4C383.738 396.4 392.2 387.938 392.2 377.5C392.2 367.062 383.738 358.6 373.3 358.6C362.862 358.6 354.4 367.062 354.4 377.5C354.4 387.938 362.862 396.4 373.3 396.4Z",
    fill: "#17B7E2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M373.3 9.2002V377.5L231.6 132.1L373.3 9.2002Z",
    fill: "#CAF4FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M373.3 0.299805V377.5L515 132.1L373.3 0.299805Z",
    fill: "#3C2791"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.300049 82.7002L373.3 377.5H90L0.300049 82.7002Z",
    fill: "#3C2791"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0.300049 82.7002L202.1 242.2L373.3 377.5L231.6 132.1L0.300049 82.7002Z",
    fill: "#6847BA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M69.4001 588.4L373.3 377.5L231.6 622.8L117.1 599.4L69.4001 588.4Z",
    fill: "#A82BB2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9001 592.8L373.3 377.5H90.0001L62.9001 592.8Z",
    fill: "#6847BA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M373.3 808.2V377.5L515 622.8L373.3 808.2Z",
    fill: "#301872"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M373.3 791.4V377.5L231.6 622.8L373.3 791.4Z",
    fill: "#D152D8"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M683.7 592.8L373.3 377.5H656.6L683.7 592.8Z",
    fill: "#6847BA"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M672.4 585L667.9 500.4L559.8 506.9L672.4 585Z",
    fill: "#E096CE"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M683.7 592.8L373.3 377.5L515 622.8L683.7 592.8Z",
    fill: "#3C2791"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M733.4 93L373.3 377.5L513.3 134.9L733.4 93Z",
    fill: "#96B5E2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M746.4 82.7002L373.3 377.5H656.6L746.4 82.7002Z",
    fill: "#3C2791"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9001 93.5L139.5 192.7L121.9 112.7L13.9001 93.5Z",
    fill: "#E096CE"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M640.5 166.3L677.5 308.9L746.4 82.7002L640.5 166.3Z",
    fill: "#301872"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M55 251.9L186.8 377.5H92.9L55 251.9Z",
    fill: "#C155C4"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M373.3 13.8999L508.2 139.4L512 142.9L517.1 141.8L731.9 96L647.1 374.5L646.5 376.5L646.8 378.6L672.7 584.6L513.2 613L509.4 613.7L507 616.8L373.3 791.8L239.6 616.8L237.2 613.7L233.4 613L74 584.7L99.9 378.7L100.2 376.6L99.6 374.6L14.8 96L229.6 141.8L234.7 142.9L238.5 139.4L373.3 13.8999ZM373.3 0.299805L231.6 132.1L0.300049 82.7002L90 377.5L63 592.9L231.7 622.9L373.4 808.3L515 622.8L683.7 592.8L656.7 377.4L746.4 82.7002L515 132.1L373.3 0.299805Z",
    fill: "#6847BA"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M574.5 602.1L513.2 613L509.4 613.7L507 616.8L486.8 643.2L496.2 647.5L515 622.8L572.5 612.6L574.5 602.1Z",
    fill: "#96B5E2"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M408.2 46.3999L488.1 120.8L489.6 108.5L415.1 39.1001L408.2 46.3999Z",
    fill: "#96B5E2"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M209 608.6L112.6 591.5L105.8 600.4L202 617.5C204.4 614.6 206.8 611.6 209 608.6Z",
    fill: "#96B5E2"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M710.4 166.6L667.2 308.4L679.2 303.4L720.9 166.3L710.4 166.6Z",
    fill: "#96B5E2"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5999 342L53.5 223.3L43.2 223.6L78.9 341L89.5999 342Z",
    fill: "#96B5E2"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M550.1 259.3L422.5 185.6C407.6 177 390.6 172.4 373.4 172.4C356.2 172.4 339.2 177 324.3 185.6L196.7 259.3C186.7 265.1 180.5 275.8 180.5 287.3V358.8C180.5 384.4 191 408.9 209.3 426.6V431.8C209.3 468.3 228.9 502.3 260.4 520.5L373.4 585.8L486.4 520.5C518.8 501.8 536.9 468.5 537.5 426.6C555.9 408.8 566.3 384.4 566.3 358.8V287.3C566.3 275.8 560.1 265.1 550.1 259.3Z",
    fill: "#1C1128"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M241.8 277.1L373.3 353L504.8 277.1L403.4 218.6C384.7 207.8 361.8 207.8 343.1 218.6L241.8 277.1Z",
    fill: "#698445"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M373.3 385.1L218.3 297.9V358.8C218.3 378.9 229 397.5 246.4 407.5L247.1 407.9V431.8C247.1 454.9 259.3 476.1 279.2 487.6L373.2 541.9L467.2 487.6C487.1 476.1 499.3 454.9 499.3 424.6V408L500 407.6C517.4 397.5 528.1 379 528.1 358.9V298L373.3 385.1Z",
    fill: "#342A44"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M403.5 218.5C394.2 213.1 383.8 210.4 373.4 210.4V353L504.9 277.1L403.5 218.5Z",
    fill: "#1F4927"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M373.3 298L247.1 280.1L373.3 353L499.5 280.1L373.3 298Z",
    fill: "#143321"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M373.3 220.5C382.1 220.5 390.8 222.8 398.4 227.2L484.8 277.1L373.3 341.5L261.8 277.1L348.2 227.2C355.8 222.8 364.5 220.5 373.3 220.5ZM373.3 210.5C362.9 210.5 352.5 213.2 343.2 218.6L241.8 277.1L373.3 353L504.8 277.1L403.4 218.6C394.1 213.2 383.7 210.5 373.3 210.5Z",
    fill: "#2B5E36"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M228.4 315.1L368.5 393.9L373.4 396.7L378.3 393.9L518.4 315.1V358.9C518.4 375.4 509.5 390.7 495.3 399L494.6 399.4L489.6 402.3V408.1V424.8C489.6 450.1 480.2 468.9 462.5 479.1L373.5 530.5L284.5 479.1C267.8 469.5 257.4 451.4 257.4 432V408V402.2L252.4 399.3L251.7 398.9C237.4 390.7 228.6 375.3 228.6 358.8V315.1H228.4ZM528.3 298L373.3 385.2L218.3 298V358.9C218.3 379 229 397.6 246.4 407.6L247.1 408V431.9C247.1 455 259.3 476.2 279.2 487.7L373.2 542L467.2 487.7C487.1 476.2 499.3 455 499.3 424.7V408L500 407.6C517.4 397.5 528.1 379 528.1 358.9V298H528.3Z",
    fill: "#443B59"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M373.3 172.5C390.5 172.5 407.5 177.1 422.4 185.7L550 259.4C560 265.2 566.2 275.9 566.2 287.4V358.9C566.2 384.5 555.7 409 537.4 426.7C536.8 468.6 518.8 501.9 486.3 520.6L373.3 585.9L260.3 520.6C228.8 502.4 209.2 468.4 209.2 431.9V426.7C190.8 408.9 180.4 384.5 180.4 358.9V287.4C180.4 275.9 186.6 265.1 196.6 259.4L324.2 185.7C339.1 177 356.1 172.5 373.3 172.5ZM373.3 162.5C354.3 162.5 335.6 167.5 319.2 177L191.6 250.7C178.5 258.2 170.4 272.3 170.4 287.4V358.9C170.4 385.6 180.9 411.5 199.2 430.8V431.9C199.2 472 220.7 509.3 255.3 529.2L368.3 594.5L373.3 597.4L378.3 594.5L491.3 529.2C525.8 509.3 545.6 474.5 547.3 430.9C565.7 411.6 576.2 385.5 576.2 358.8V287.3C576.2 272.2 568.1 258.2 555 250.6L427.5 177C411 167.5 392.3 162.5 373.3 162.5Z",
    fill: "#6847BA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaster1);
export default __webpack_public_path__ + "static/media/master-1.671b49b542024fc932524d6ed8e4a37f.svg";
export { ForwardRef as ReactComponent };